import {TNormalizedProduct} from '@/sites/purchase/typedef'

export const filterPriceById = (
  prices: Array<TNormalizedProduct>,
  productIds: Array<string>
) => prices.filter(price => productIds.includes(price.productId))
